import { jsxs as f, jsx as l, Fragment as a } from "react/jsx-runtime";
import { Fragment as u } from "react";
import { i as s } from "../type-BFTbooL7.js";
function x(o, i) {
  return s(o) ? "" : o.split("{").map((r) => {
    const n = r.indexOf("}");
    if (n === -1)
      return r;
    const e = r.substring(0, n), t = i[e];
    return s(t) ? (console.error(`resolveToString: value for key "${e}" not provided`), "") : r.replace(`${e}}`, String(t));
  }).join("");
}
const m = {};
function y(o, i = m) {
  if (s(o))
    return "";
  const c = o.split("{").map((r) => {
    const n = r.indexOf("}");
    if (n === -1)
      return r;
    const e = r.substring(0, n), t = i[e];
    return s(t) ? (console.error(`resolveToComponent: value for key "${e}" not provided`), null) : /* @__PURE__ */ f(u, { children: [
      t,
      r.replace(`${e}}`, "")
    ] }, e);
  });
  return /* @__PURE__ */ l(a, { children: c.map((r, n) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ l(u, { children: r }, n)
  )) });
}
export {
  y as resolveToComponent,
  x as resolveToString
};
